import React from 'react';

import { MdChat as ChatIcon } from 'react-icons/md';
const Chat = ({ size = 1 }: { size?: number }) => <ChatIcon size={size * 15} />;

export default Chat;
